import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../../Components/Common/ParticlesAuth";
import ManualInstallLink from "../../Components/Common/ManualInstallLink";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, resetLoginFlag } from "../../slices/thunks";

import logoLight from "../../assets/images/full_logo.png";
import { createSelector } from 'reselect';
//import images

const Login = (props: any) => {
    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Account.user,
            error: state.Login.error,
            errorMsg: state.Login.errorMsg,
        })
    );
    // Inside your component
    const {
        user, error, errorMsg
    } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState<any>([]);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);

    const [loader, setLoader] = useState<boolean>(false);


    useEffect(() => {
        if (user && user) {
            const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.email : user.email;
            const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.confirm_password;
            setUserLogin({
                email: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser(values, props.router.navigate));
            setLoader(true)
        }
    });

    useEffect(() => {
        if (errorMsg) {
            const timer = setTimeout(() => {
                dispatch(resetLoginFlag());
                setLoader(false)
            }, 6000); // Auto-close after 6 seconds

            return () => clearTimeout(timer); // Cleanup timer on unmount
        }
    }, [dispatch, errorMsg]);

    document.title = "Login | Atos Cloud";
    return (
        <React.Fragment>
            <style>{`
                @media (max-width: 576px) {
                    .auth-page-content-mobile {
                        margin-top: -40px !important;
                    }
                    .auth-logo-mobile {
                        margin-top: 30px !important;
                        margin-bottom: 0 !important;
                    }
                    .auth-logo-mobile img {
                        height: 120px !important;
                        max-width: 90vw !important;
                    }
                    .auth-card-mobile {
                        margin-top: 0.75rem !important;
                    }
                }
                @media (min-width: 577px) {
                    .auth-page-content-mobile {
                        margin-top: -120px !important;
                    }
                    .auth-logo-mobile {
                        margin-top: 100px !important;
                    }
                    .auth-logo-mobile img {
                        height: 240px !important;
                    }
                    .auth-card-mobile {
                        margin-top: 1rem !important;
                    }
                }
            `}</style>
            <ParticlesAuth>
                <div className="auth-page-content auth-page-content-mobile">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 text-white-50 auth-logo-mobile" style={{ marginBottom: '0' }}>
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo" style={{ background: 'transparent' }}>
                                            <img src={`${logoLight}?v=${Date.now()}`} alt="AtosCloud Logo" style={{ background: 'transparent', display: 'block' }} />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4 card-bg-fill auth-card-mobile">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Bem-vindo!</h5>
                                            <p className="text-muted">Entre para continuar no Atos Sistema Contábil.</p>
                                        </div>
                                        {error && error ? (
                                            <Alert
                                                color="danger"
                                                isOpen={!!error}
                                                toggle={() => {
                                                    dispatch(resetLoginFlag());
                                                    setLoader(false);
                                                }}
                                                className="alert-dismissible"
                                            >
                                                {error}
                                            </Alert>
                                        ) : null}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Email</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Lembrar-me</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button color="success"
                                                        disabled={loader && true}
                                                        className="btn btn-success w-100" type="submit">
                                                        {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                        Entrar
                                                    </Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Não tem uma conta? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Registrar </Link> </p>
                                                </div>
                                            </Form>

                                            {/* Manual Install Link - Shows only on smartphones */}
                                            <ManualInstallLink />
                                        </div>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);